import gql from 'graphql-tag';

export default gql`
  fragment QueryFragment on QueryInfo {
    endCursor
    hasNextPage
    offset
    totalCount
    sortBy
    isAsc
  }
`;
